import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import SummaryApi from "../../../common";
import "./loader.css";

const WardDetails = () => {
  const { wardno } = useParams();
  const [userName, setUserName] = useState("");
  const [voters, setVoters] = useState([]);
  const [allowedColumns, setAllowedColumns] = useState([]);
  const [scrollAtBottom, setScrollAtBottom] = useState(false);
  const [filteredVoters, setFilteredVoters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchSrNo, setSearchSrNo] = useState("");
  // Filters
  const [searchName, setSearchName] = useState("");
  const [searchRelative, setSearchRelative] = useState("");
  const [genderFilter, setGenderFilter] = useState("");
  const [ageMin, setAgeMin] = useState("");
  const [ageMax, setAgeMax] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchEpicNo, setSearchEpicNo] = useState("");
  const [searchPartNo, setSearchPartNo] = useState("");
  const [marks, setMarks] = useState({});
  const [status, setStatus] = useState({});
  const [selectedVoter, setSelectedVoter] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({
    voterName: "",
    relativeName: "",
    mobileNo: "",
    cast: "",
    workDone: "",
    other: "",
  });
  const [selectedSurname, setSelectedSurname] = useState(null);

  const markCounts = { आपले: 0, विरोधी: 0, संदिग्ध: 0, इतर: 0 };

  const statusCounts = { Pending: 0, Done: 0, Unmarked: 0 };

  filteredVoters.forEach((v) => {
    const mark = marks[v._id];
    const stat = status[v._id];

    // Count mark types
    if (markCounts.hasOwnProperty(mark)) markCounts[mark]++;

    // Count status
    if (stat === "Pending") statusCounts.Pending++;
    else if (stat === "Done") statusCounts.Done++;
    else statusCounts.Unmarked++; // If no status yet
  });

  const storedUser = JSON.parse(localStorage.getItem("umedwarUser"));
  // Fetch all voters once

  useEffect(() => {
    const storedUserJSON = localStorage.getItem("umedwarUser");

    if (storedUserJSON) {
      try {
        const storedUser = JSON.parse(storedUserJSON);

        console.log("🧩 Loaded user from localStorage:", storedUser);

        if (storedUser.fullName) setUserName(storedUser.fullName);

        // ✅ Safely check if allowedColumns is a valid array
        if (
          Array.isArray(storedUser.allowedColumns) &&
          storedUser.allowedColumns.length > 0
        ) {
          setAllowedColumns(storedUser.allowedColumns);
          console.log("✅ Allowed columns:", storedUser.allowedColumns);
        } else {
          console.warn(
            "⚠️ allowedColumns missing or empty — showing all columns"
          );
          setAllowedColumns([]);
        }
      } catch (err) {
        console.error("❌ Error parsing user from localStorage:", err);
      }
    } else {
      console.warn("⚠️ No user found in localStorage!");
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    fetch(SummaryApi.GetMatdar.url)
      .then((res) => res.json())
      .then((data) => {
        const votersArray = Array.isArray(data) ? data : [];
        setVoters(votersArray);
        // Initially filter by ward number
        setFilteredVoters(votersArray.filter((v) => v.wardNumber === wardno));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching voters:", err);
        setLoading(false);
      });
  }, [wardno]);

  useEffect(() => {
    let filtered = voters.filter((v) => v.wardNumber === wardno); // start with ward filter

    if (searchSrNo)
      filtered = filtered.filter((v) => v.srNo?.toString() === searchSrNo); // exact match

    if (searchName)
      filtered = filtered.filter((v) =>
        v.voterName?.toLowerCase().includes(searchName.toLowerCase())
      );

    if (searchRelative)
      filtered = filtered.filter((v) =>
        v.relativeName?.toLowerCase().includes(searchRelative.toLowerCase())
      );

    if (genderFilter)
      filtered = filtered.filter((v) => v.gender === genderFilter);

    if (ageMin) filtered = filtered.filter((v) => v.age >= parseInt(ageMin));
    if (ageMax) filtered = filtered.filter((v) => v.age <= parseInt(ageMax));

    if (searchEpicNo)
      filtered = filtered.filter(
        (v) =>
          v.epicNo &&
          v.epicNo.toLowerCase().includes(searchEpicNo.toLowerCase())
      );

    if (searchPartNo)
      filtered = filtered.filter(
        (v) => v.acPartNo && v.acPartNo.toString().includes(searchPartNo)
      );

    // Alphabetical sorting by voterName
    if (sortOrder === "asc") {
      filtered = filtered.sort((a, b) =>
        a.voterName.localeCompare(b.voterName)
      );
    } else if (sortOrder === "desc") {
      filtered = filtered.sort((a, b) =>
        b.voterName.localeCompare(a.voterName)
      );
    }

    setFilteredVoters(filtered);
  }, [
    searchSrNo,
    searchName,
    searchRelative,
    genderFilter,
    ageMin,
    ageMax,
    searchEpicNo,
    searchPartNo,
    voters,
    wardno,
    sortOrder,
  ]);

  const handleGeneratePDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(20);
    doc.text("Confidential Voter Data", 20, 20);
    doc.setFontSize(10);
    doc.text("Unauthorized sharing or distribution is prohibited.", 20, 28);

    const securityId = `SEC-${Date.now()}`;
    doc.text(`Security ID: ${securityId}`, 20, 35);

    const storedUser = JSON.parse(localStorage.getItem("umedwarUser"));
    if (storedUser?.fullName) {
      doc.text(`Downloaded by: ${storedUser.fullName}`, 20, 42);
    }

    // ✅ Use autoTable properly
    autoTable(doc, {
      startY: 50,
      head: [["Name", "Relative", "House No", "Age", "Gender"]],
      body: filteredVoters.map((v) => [
        v.voterName,
        v.relativeName,
        v.houseNo,
        v.age,
        v.gender,
      ]),
    });

    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setTextColor(200);
      doc.text("CONFIDENTIAL", 50, 150, { angle: 45 });
    }

    doc.save(`Ward_${wardno}_Voters_${securityId}.pdf`);
  };

  useEffect(() => {
    const handleScroll = () => {
      const isBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 2;
      setScrollAtBottom(isBottom);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      // ✅ Decide whose number to send based on role
      const markedBy =
        storedUser?.role?.toUpperCase() === "ADMIN"
          ? storedUser?.mobile || "Unknown"
          : storedUser?.createdBy || storedUser?.mobile || "Unknown";

      console.debug("Fetching data with markedBy:", markedBy);

      // Fetch all voters
      const res = await fetch(SummaryApi.GetMatdar.url);
      const data = await res.json();

      const votersArray = Array.isArray(data) ? data : [];
      const wardVoters = votersArray.filter(
        (v) => v.wardNumber === wardno
      );

      setVoters(votersArray);
      setFilteredVoters(wardVoters);

      // ✅ Fetch existing marks with correct markedBy (admin/mobile or createdBy)
      const markRes = await fetch(
        `${SummaryApi.GetVoterMark.url}/${wardno}/${markedBy}`
      );
      const markData = await markRes.json();

      const markMap = {};
      markData.forEach((m) => {
        markMap[m.voterId._id] = m.markType;
      });
      setMarks(markMap);

      // ✅ Fetch status marks with same logic
      const markStatus = await fetch(
        `${SummaryApi.GetVoterStatusMark.url}/${wardno}/${markedBy}`
      );
      const markStatusData = await markStatus.json();

      const markStatusMap = {};
      markStatusData.forEach((m) => {
        markStatusMap[m.voterId._id] = m.status;
      });
      setStatus(markStatusMap);

    } catch (err) {
      console.error("Error in fetchData:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [wardno]);


  // Helper to decide markedBy value
  const getMarkedBy = (user) => {
    if (!user) return "Unknown";
    const role = (user.role || "").toString().toUpperCase();
    // if ADMIN -> use mobile, otherwise use createdBy (fallback to mobile then Unknown)
    return role === "ADMIN"
      ? user.mobile || "Unknown"
      : user.createdBy || user.mobile || "Unknown";
  };

  const handleMarkVoter = async (voterId, markType) => {
    try {
      if (!wardno) {
        console.error("wardno is missing");
        return;
      }

      const markedBy = getMarkedBy(storedUser);
      console.debug("handleMarkVoter ->", {
        voterId,
        markType,
        markedBy,
        wardno,
        storedUser,
      });

      const headers = { "Content-Type": "application/json" };
      // if you use an auth token, include it:
      if (storedUser?.token)
        headers["Authorization"] = `Bearer ${storedUser.token}`;

      const res = await fetch(`${SummaryApi.VoterMark.url}/${wardno}`, {
        method: "POST",
        headers,
        body: JSON.stringify({ voterId, markedBy, markType }),
      });

      // try to parse JSON but fallback to text if server returns something unexpected
      let data;
      try {
        data = await res.json();
      } catch (e) {
        data = await res.text();
      }

      console.debug("handleMarkVoter response:", {
        status: res.status,
        ok: res.ok,
        data,
      });

      if (res.ok) {
        setMarks((prev) => ({ ...prev, [voterId]: markType }));
      } else {
        // give more info in alert and console
        const msg = (data && data.message) || data || "Error marking voter";
        console.error("Error marking voter:", msg);
        alert(msg);
      }
    } catch (err) {
      console.error("Error marking voter (exception):", err);
      alert("Unexpected error marking voter. See console for details.");
    }
  };

  const handleStatusMarkVoter = async (voterId, statusValue) => {
    try {
      if (!wardno) {
        console.error("wardno is missing");
        return;
      }

      const markedBy = getMarkedBy(storedUser);
      console.debug("handleStatusMarkVoter ->", {
        voterId,
        statusValue,
        markedBy,
        wardno,
        storedUser,
      });

      const headers = { "Content-Type": "application/json" };
      if (storedUser?.token)
        headers["Authorization"] = `Bearer ${storedUser.token}`;

      const res = await fetch(`${SummaryApi.VoterStatusMark.url}/${wardno}`, {
        method: "POST",
        headers,
        body: JSON.stringify({ voterId, markedBy, status: statusValue }),
      });

      let data;
      try {
        data = await res.json();
      } catch (e) {
        data = await res.text();
      }

      console.debug("handleStatusMarkVoter response:", {
        status: res.status,
        ok: res.ok,
        data,
      });

      if (res.ok) {
        setStatus((prev) => ({ ...prev, [voterId]: statusValue }));
      } else {
        const msg = (data && data.message) || data || "Error marking status";
        console.error("Error marking status:", msg);
        alert(msg);
      }
    } catch (err) {
      console.error("Error marking status (exception):", err);
      alert("Unexpected error marking status. See console for details.");
    }
  };

  // ✅ Define all available columns (Marathi labels must match DB)
  const allColumnDefs = [
    { key: "srNo", label: "Sr.No." },
    { key: "voterName", label: "नाव" },
    { key: "relativeName", label: "नाते" },
    { key: "epicNo", label: "Epic No." },
    { key: "gender", label: "लिंग" },
    { key: "acPartNo", label: "Part No" },
    { key: "mobileNo", label: "Mobile No." },
    { key: "cast", label: "जात" },
    { key: "workDone", label: "कामे" },
    { key: "other", label: "other" },
  ];

  // ✅ Columns that should always be visible
  const alwaysVisible = [
    { key: "mark", label: "Mark" },
    { key: "status", label: "Status" },
  ];

  // ✅ Filter visible columns
  const visibleColumns = (() => {
    // Always include Mark + Status
    const baseColumns = [...alwaysVisible];

    // If allowedColumns exist, show only those
    if (allowedColumns && allowedColumns.length > 0) {
      const allowed = allColumnDefs.filter((col) =>
        allowedColumns.includes(col.label)
      );
      return [...allowed, ...baseColumns];
    }

    // If no allowedColumns defined, show everything
    return [...allColumnDefs, ...baseColumns];
  })();

  const handleSaveVoterDetails = async () => {
    try {
      const res = await fetch(
        `${SummaryApi.UpdateMatdarDetails.url}/${selectedVoter._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(editData),
        }
      );

      const data = await res.json();
      if (res.ok) {
        // Update local state instantly
        setFilteredVoters((prev) =>
          prev.map((v) =>
            v._id === selectedVoter._id ? { ...v, ...editData } : v
          )
        );

        setShowModal(false);
      } else {
        alert(data.message || "Failed to update voter details");
      }
    } catch (err) {
      console.error("Error updating voter:", err);
    }
  };

  const surnames = useMemo(() => {
    const surnameSet = new Set();
    filteredVoters.forEach((v) => {
      if (v.voterName) {
        const surname = v.voterName.trim().split(" ")[0];
        if (surname) surnameSet.add(surname);
      }
    });
    return Array.from(surnameSet).sort();
  }, [filteredVoters]);

  const votersToShow = useMemo(() => {
    if (!selectedSurname) return filteredVoters;
    return filteredVoters.filter((v) =>
      v.voterName?.trim().startsWith(selectedSurname)
    );
  }, [filteredVoters, selectedSurname]);

  if (loading)
    return (
      <section className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-blue-50 to-blue-100">
        <div className="book">
          <div className="book__pg-shadow"></div>
          <div className="book__pg"></div>
          <div className="book__pg book__pg--2"></div>
          <div className="book__pg book__pg--3"></div>
          <div className="book__pg book__pg--4"></div>
          <div className="book__pg book__pg--5"></div>
        </div>

        <p className="mt-8 text-blue-700 text-lg font-semibold animate-pulse text-center">
          🗳️ मतदारांची गणना सुरू आहे... कृपया थोडा वेळ थांबा!
        </p>
      </section>
    );

  if (!userName) {
    return (
      <div className="p-6 text-center mt-20">
        <h1 className="text-2xl font-bold text-red-600 mb-4">
          Access Restricted
        </h1>
        <p className="text-lg text-gray-700">
          You need to purchase a subscription to access this page.
        </p>
        <p className="text-blue-700 font-semibold mt-2">Contact: 9309140606</p>
        <Link
          to="/"
          className="inline-block mt-6 bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          ← Go Back
        </Link>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4 text-center sm:text-left">
        <Link
          to="/matdar-dashboard"
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 mb-2 sm:mb-0"
        >
          ← मागे जा
        </Link>

        <h1 className="text-xl sm:text-2xl font-bold text-blue-700 sm:pl-10">
          वार्ड क्रमांक: {wardno}
        </h1>

        {userName && (
          <p className="hidden sm:block text-blue-700 font-semibold ml-auto">
            Logged in as: {userName}
          </p>
        )}
      </div>

      {/* Filter Inputs */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mb-6">
        <input
          type="text"
          placeholder="Sr.No शोधा"
          value={searchSrNo}
          onChange={(e) => setSearchSrNo(e.target.value)}
          className="border p-2 rounded w-full"
        />
        <input
          type="text"
          placeholder="नाव शोधा"
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          className="border p-2 rounded w-full"
        />
        <input
          type="text"
          placeholder="नाते शोधा"
          value={searchRelative}
          onChange={(e) => setSearchRelative(e.target.value)}
          className="border p-2 rounded w-full"
        />
        <input
          type="text"
          placeholder="EPIC No"
          value={searchEpicNo}
          onChange={(e) => setSearchEpicNo(e.target.value)}
          className="border p-2 rounded w-full"
        />
        <input
          type="text"
          placeholder="Part No"
          value={searchPartNo}
          onChange={(e) => setSearchPartNo(e.target.value)}
          className="border p-2 rounded w-full"
        />
        <select
          value={genderFilter}
          onChange={(e) => setGenderFilter(e.target.value)}
          className="border p-2 rounded w-full"
        >
          <option value="">सर्व लिंग</option>
          <option value="M">पुरुष</option>
          <option value="F">स्त्री</option>
          <option value="Other">इतर</option>
        </select>

        <div className="flex items-center gap-2 border p-2 rounded w-full">
          <label className="font-semibold text-gray-700 whitespace-nowrap">
            Sort:
          </label>
          <select
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            className="border border-gray-300 rounded-md p-2 w-full focus:ring-2 focus:ring-blue-500"
          >
            <option value="">None</option>
            <option value="asc">A → Z</option>
            <option value="desc">Z → A</option>
          </select>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        <button
          onClick={() => setSelectedSurname(null)}
          className={`px-3 py-1 rounded text-sm font-medium border ${
            !selectedSurname
              ? "bg-blue-500 text-white border-blue-500"
              : "bg-gray-100 hover:bg-gray-200 border-gray-400"
          }`}
        >
          All
        </button>
        {/* {surnames.map((surname) => (
          <button
            key={surname}
            onClick={() => setSelectedSurname(surname)}
            className={`px-3 py-1 rounded text-sm font-medium border ${
              selectedSurname === surname
                ? "bg-blue-500 text-white border-blue-500"
                : "bg-gray-100 hover:bg-gray-200 border-gray-400"
            }`}
          >
            {surname}
          </button>
        ))} */}
      </div>

      <button
        onClick={scrollAtBottom ? scrollToTop : scrollToBottom}
        className="fixed bottom-8 right-8 bg-blue-600 text-white px-4 py-3 rounded-full shadow-lg hover:bg-blue-700 transition"
      >
        {scrollAtBottom ? "↑ Top" : "↓ Bottom"}
      </button>

      {filteredVoters.length === 0 ? (
        <p className="text-center text-gray-600">
          या वार्डमध्ये मतदार सापडले नाहीत.
        </p>
      ) : (
        <div className="overflow-x-auto">
          <div className="flex flex-wrap justify-between items-center mb-3">
            <div className="font-semibold">
              Total Voters Shown: {filteredVoters.length}
            </div>

            <div className="flex flex-wrap gap-3 text-sm pt-10">
              <div className="px-3 py-1 rounded bg-green-100 border border-green-400">
                आपले:{" "}
                <span className="font-semibold">{markCounts["आपले"]}</span>
              </div>
              <div className="px-3 py-1 rounded bg-red-100 border border-red-400">
                विरोधी:{" "}
                <span className="font-semibold">{markCounts["विरोधी"]}</span>
              </div>
              <div className="px-3 py-1 rounded bg-yellow-100 border border-yellow-400">
                संदिग्ध:{" "}
                <span className="font-semibold">{markCounts["संदिग्ध"]}</span>
              </div>
              <div className="px-3 py-1 rounded bg-gray-100 border border-gray-400">
                इतर: <span className="font-semibold">{markCounts["इतर"]}</span>
              </div>

              {/* Status counts */}
            </div>
            <div className="flex flex-wrap gap-3 text-sm pt-10">
              <div className="px-3 py-1 rounded bg-blue-100 border border-blue-400">
                Pending:{" "}
                <span className="font-semibold">{statusCounts.Pending}</span>
              </div>
              <div className="px-3 py-1 rounded bg-indigo-100 border border-indigo-400">
                Done: <span className="font-semibold">{statusCounts.Done}</span>
              </div>
              <div className="px-3 py-1 rounded bg-gray-200 border border-gray-400">
                Unmarked:{" "}
                <span className="font-semibold">{statusCounts.Unmarked}</span>
              </div>
            </div>
          </div>
          <table className="w-full border">
            <thead className="bg-gray-100">
              <tr>
                {visibleColumns.map((col) => (
                  <th key={col.key} className="border px-2 py-1">
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {votersToShow.map((v, i) => {
                const markType = marks[v._id] || "";
                const statusValue = status[v._id] || "";

                let rowColor = "";
                if (markType === "आपले") rowColor = "bg-green-100";
                else if (markType === "विरोधी") rowColor = "bg-red-100";
                else if (markType === "संदिग्ध") rowColor = "bg-yellow-100";
                else if (markType === "इतर") rowColor = "bg-gray-100";

                return (
                  <tr
                    key={v._id || i}
                    className={`${rowColor} hover:bg-blue-50 cursor-pointer transition`}
                    onClick={() => {
                      setSelectedVoter(v);
                      setEditData({
                        voterName: v.voterName || "",
                        relativeName: v.relativeName || "",
                        mobileNo: v.mobileNo || "",
                        cast: v.cast || "",
                        workDone: v.workDone || "",
                        other: v.other || "",
                      });

                      setShowModal(true);
                    }}
                  >
                    {visibleColumns.map((col) => {
                      if (col.key === "mark") {
                        return (
                          <td
                            key={col.key}
                            className="border px-2 py-1 text-center"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <select
                              value={markType}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleMarkVoter(v._id, e.target.value);
                              }}
                              className="border rounded p-1 text-sm bg-white"
                            >
                              <option value="">-- निवडा --</option>
                              <option value="आपले">आपले</option>
                              <option value="विरोधी">विरोधी</option>
                              <option value="संदिग्ध">संदिग्ध</option>
                              <option value="इतर">इतर</option>
                            </select>
                          </td>
                        );
                      } else if (col.key === "status") {
                        return (
                          <td
                            key={col.key}
                            className="border px-2 py-1 text-center"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <select
                              value={statusValue}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleStatusMarkVoter(v._id, e.target.value);
                              }}
                              className="border rounded p-1 text-sm bg-white"
                            >
                              <option value="">-- निवडा --</option>
                              <option value="Pending">Pending</option>
                              <option value="Done">Done</option>
                            </select>
                          </td>
                        );
                      } else {
                        return (
                          <td key={col.key} className="border px-2 py-1">
                            {v[col.key] || ""}
                          </td>
                        );
                      }
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {showModal && selectedVoter && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-11/12 max-w-lg relative max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header with sticky close button */}
            <div className="sticky top-0 bg-white z-10 flex justify-between items-center border-b pb-2 pt-3 px-6">
              <h2 className="text-xl font-bold text-blue-700">
                मतदार माहिती (Voter Details)
              </h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-600 hover:text-red-500 text-2xl font-bold leading-none"
              >
                ✕
              </button>
            </div>

            {/* Scrollable modal content */}
            <div className="overflow-y-auto p-6 space-y-3">
              {visibleColumns
                .filter((col) => col.key !== "mark" && col.key !== "status")
                .map((col) => {
                  const isEditableField = [
                    "voterName",
                    "relativeName",
                    "mobileNo",
                    "cast",
                    "workDone",
                    "other",
                  ].includes(col.key);

                  const isAllowed =
                    allowedColumns.length === 0 ||
                    allowedColumns.includes(col.label);

                  if (!isAllowed) return null;

                  return (
                    <div key={col.key} className="flex flex-col border-b pb-2">
                      <label className="font-semibold text-gray-700 mb-1">
                        {col.label}:
                      </label>

                      {isEditableField ? (
                        col.key === "workDone" || col.key === "other" ? (
                          <textarea
                            rows={3}
                            value={editData[col.key]}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                [col.key]: e.target.value,
                              })
                            }
                            className="border p-2 rounded text-sm resize-none w-full"
                            placeholder={`Enter ${col.label}`}
                          ></textarea>
                        ) : (
                          <input
                            type="text"
                            value={editData[col.key]}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                [col.key]: e.target.value,
                              })
                            }
                            className="border p-2 rounded text-sm w-full"
                            placeholder={`Enter ${col.label}`}
                          />
                        )
                      ) : (
                        <span className="text-gray-800 break-words whitespace-pre-wrap">
                          {selectedVoter[col.key] || "—"}
                        </span>
                      )}
                    </div>
                  );
                })}

              {/* Save Button — visible only if user can edit */}
              {(allowedColumns.length === 0 ||
                allowedColumns.some((col) =>
                  ["Mobile No.", "जात", "कामे", "other"].includes(col)
                )) && (
                <button
                  onClick={handleSaveVoterDetails}
                  className="w-full bg-blue-600 text-white py-2 rounded mt-3 hover:bg-blue-700 transition"
                >
                  Save Changes
                </button>
              )}

              {/* Mark & Status Section */}
              <div className="mt-6 flex flex-wrap gap-4 justify-between">
                <div>
                  <label className="font-semibold text-gray-700">Mark:</label>
                  <select
                    value={marks[selectedVoter._id] || ""}
                    onChange={(e) =>
                      handleMarkVoter(selectedVoter._id, e.target.value)
                    }
                    className="border rounded p-1 text-sm ml-2"
                  >
                    <option value="">-- निवडा --</option>
                    <option value="आपले">आपले</option>
                    <option value="विरोधी">विरोधी</option>
                    <option value="संदिग्ध">संदिग्ध</option>
                    <option value="इतर">इतर</option>
                  </select>
                </div>

                <div>
                  <label className="font-semibold text-gray-700">Status:</label>
                  <select
                    value={status[selectedVoter._id] || ""}
                    onChange={(e) =>
                      handleStatusMarkVoter(selectedVoter._id, e.target.value)
                    }
                    className="border rounded p-1 text-sm ml-2"
                  >
                    <option value="">-- निवडा --</option>
                    <option value="Pending">Pending</option>
                    <option value="Done">Done</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WardDetails;
